import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=38f15a23&scoped=true&"
import script from "./wizard.vue?vue&type=script&lang=js&"
export * from "./wizard.vue?vue&type=script&lang=js&"
import style0 from "./wizard.vue?vue&type=style&index=0&id=38f15a23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f15a23",
  null
  
)

export default component.exports